import {Language} from '@tisa-group/models';

export const SUPPORTED_LANGUAGES: Language[] = ['pl', 'en', 'lt', 'pt', 'fr']; // all possible laguages for all clients
